import { APIStatus } from '@application/common/enums/api-status';
import { createSlice } from '@reduxjs/toolkit';
import { getLoggedHoursPerDayByIdAsync, registerHoursPerDayAsync, getHoursByTimeSheetIds, bulkRegisterHoursAsync, getMonthListByAssignmentAndFreelancerId, getYearListByAssignmentAndFreelancerId, getWeekDaysByMonthYearWeekNoAndAssignmentIdAsync, reSyncBusinessCentralHoursByTimeSheetIdsAsync } from './hoursRegistrationThunk';
const initialState = {
    status: APIStatus.IDLE
};
export const hoursRegistrationStateSlice = createSlice({
    name: 'hoursRegistration',
    initialState,
    reducers: {
        resetMonthList: (state) => {
            state.monthList = [];
        },
        resetYearList: (state) => {
            state.yearList = [];
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getWeekDaysByMonthYearWeekNoAndAssignmentIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getWeekDaysByMonthYearWeekNoAndAssignmentIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.hoursLoggedWrtAssigmentId = action.payload;
        })
            .addCase(getWeekDaysByMonthYearWeekNoAndAssignmentIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getHoursByTimeSheetIds.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getHoursByTimeSheetIds.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.hoursByTimeSheetId = action.payload;
        })
            .addCase(getHoursByTimeSheetIds.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(registerHoursPerDayAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(registerHoursPerDayAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.hourLogged = action.payload;
        })
            .addCase(registerHoursPerDayAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(bulkRegisterHoursAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(bulkRegisterHoursAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
        })
            .addCase(bulkRegisterHoursAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getLoggedHoursPerDayByIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getLoggedHoursPerDayByIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.hoursLoggedPerDay = action.payload;
        })
            .addCase(getLoggedHoursPerDayByIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getMonthListByAssignmentAndFreelancerId.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getMonthListByAssignmentAndFreelancerId.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.monthList = action.payload;
        })
            .addCase(getMonthListByAssignmentAndFreelancerId.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getYearListByAssignmentAndFreelancerId.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getYearListByAssignmentAndFreelancerId.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.yearList = action.payload;
        })
            .addCase(getYearListByAssignmentAndFreelancerId.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(reSyncBusinessCentralHoursByTimeSheetIdsAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(reSyncBusinessCentralHoursByTimeSheetIdsAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.hoursByTimeSheetId = action.payload;
        })
            .addCase(reSyncBusinessCentralHoursByTimeSheetIdsAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    }
});
export const { resetMonthList, resetYearList } = hoursRegistrationStateSlice.actions;
export default hoursRegistrationStateSlice.reducer;
